import React from "react";
import { motion } from "framer-motion";

const PolicyLayout = ({ title, children }) => {
  return (
    <div className="bg-white min-h-screen pt-10 pb-20">
      <div className="max-w-4xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl md:text-5xl font-black text-gray-dark mb-8 tracking-tight">
            {title}
          </h1>
          <div className="prose prose-orange max-w-none text-gray-600 leading-relaxed space-y-6 font-medium">
            {children}
          </div>
        </motion.div>
      </div>
    </div>
  );
};

const CancellationPolicy = () => {
  return (
    <PolicyLayout title="Cancellation Policy">
      <p>At Khajuraho Routes, we understand that plans can change. Our cancellation policy is designed to balance the needs of our travelers with the commitments we make to our local guides and hotel partners in Khajuraho and surrounding areas.</p>
      
      <section>
        <h2 className="text-2xl font-bold text-gray-dark mt-8 mb-4">1. How to Cancel</h2>
        <p>All cancellation requests must be submitted in writing via email to <strong>khajurahoroutes@gmail.com</strong> or by contacting our support team at <strong>+91 99939 10094</strong>. The date of the email or call will be considered the official cancellation date.</p>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-gray-dark mt-8 mb-4">2. Tour Cancellation Charges</h2>
        <div className="bg-gray-50 p-6 rounded-2xl border border-gray-100">
          <ul className="space-y-4">
            <li className="flex items-start gap-3">
              <span className="w-1.5 h-1.5 bg-orange-main rounded-full mt-2 shrink-0" />
              <p><strong>30 days or more before arrival:</strong> 10% of the total tour cost will be charged as a processing fee. Remaining 90% will be refunded.</p>
            </li>
            <li className="flex items-start gap-3">
              <span className="w-1.5 h-1.5 bg-orange-main rounded-full mt-2 shrink-0" />
              <p><strong>15 to 29 days before arrival:</strong> 50% of the total tour cost will be charged as cancellation fees.</p>
            </li>
            <li className="flex items-start gap-3">
              <span className="w-1.5 h-1.5 bg-orange-main rounded-full mt-2 shrink-0" />
              <p><strong>Less than 15 days before arrival:</strong> No refund will be provided (100% cancellation charges apply).</p>
            </li>
          </ul>
        </div>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-gray-dark mt-8 mb-4">3. Special Circumstances</h2>
        <p>In case of monument closures in Khajuraho or unforeseen government restrictions, we will attempt to provide an alternative date or a credit note for future travel. However, refunds in such cases are subject to the policies of our vendors (hotels/transport).</p>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-gray-dark mt-8 mb-4">4. No Show Policy</h2>
        <p>If a guest fails to arrive at the designated meeting point in Khajuraho or Jabalpur without prior notice, it will be treated as a "No Show" and no refund or rescheduling will be permitted.</p>
      </section>
    </PolicyLayout>
  );
};

export default CancellationPolicy;
